import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Image, Nav, Navbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CrowDeLogo from '../logo_branco.png';
import * as loginAction from '../services/login/Action';
import * as Constants from '../utils/constants';

class NavigationBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {

    let username = window.sessionStorage.getItem('username')

    return (
      <Navbar bg="blue" variant="dark" expand="lg" className="text-white">
        <Navbar.Brand> <Image src={CrowDeLogo} height='35' width='65'></Image></Navbar.Brand>
        {this.props.autenticado &&
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <NavLink className="nav-item nav-link" exact activeClassName="active" to={Constants.ROUTE_URL_HOME}>{Constants.DESCRICAO_INICIO}</NavLink>
              <NavLink className="nav-item nav-link" activeClassName="active" to={Constants.ROUTE_URL_AGRICULTORES} >{Constants.DESCRICAO_PESSOA}</NavLink>
              {/* <NavLink className="nav-item nav-link" activeClassName="active" to={Constants.ROUTE_URL_SOBRE}>{Constants.DESCRICAO_SOBRE}</NavLink> */}
              <NavLink className="nav-item nav-link" activeClassName="active" to={Constants.ROUTE_URL_TRANSPORTADORAS}>{Constants.DESCRICAO_MOTORISTAS}</NavLink>
              <NavLink className="nav-item nav-link" activeClassName="active" to={Constants.ROUTE_URL_READER_CODE}>{Constants.DESCRICAO_READER_CODE}</NavLink>
              <NavLink className="nav-item nav-link" activeClassName="active" to={Constants.ROUTE_URL_PESAGENS}>{Constants.DESCRICAO_PESAGENS}</NavLink>
              <Nav.Link href={`${Constants.API_ROOT_URL.replace("/api/v1/", "/")}admin`} >{Constants.DESCRICAO_ADMIN}</Nav.Link>
              <Nav.Link href="" onClick={this.props.logout}>{Constants.DESCRICAO_SAIR}</Nav.Link>

            </Nav>

            {
              username ? <Navbar.Collapse>
                <Nav className="justify-content-end" style={{ width: "100%" }}>
                  <strong>{`Bem vindo, ${username}`}</strong>
                </Nav>
              </Navbar.Collapse> : <></>
            }


          </Navbar.Collapse>
        }
      </Navbar>
    );
  }
}

NavigationBar.propTypes = {
  autenticado: PropTypes.bool.isRequired,
};


const mapStateToProps = state => ({
  loginObject: state.loginReducer.loginObject
});


const mapDispatchToProps = dispatch => ({
  action: bindActionCreators({ ...loginAction }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
